import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	CUSTOM_ELEMENTS_SCHEMA,
	input,
} from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';

import { TooltipModule } from '@valk-nx/components/ui-tooltip/src';
import { ReceiptSummaryExtraComponent } from '@valk-nx/compositions/ui-receipt-summary/src/lib/components/extra/extra.component';
import {
	Item,
	ItemWithExtras,
} from '@valk-nx/compositions/ui-receipt-summary/src/lib/receipt-summary.interface';
import { isItemWithExtras } from '@valk-nx/compositions/ui-receipt-summary/src/lib/type-guards/type-guards';
import { SharedModule } from '@valk-nx/core/lib/modules/shared.module';
import { CapitalizePipe } from '@valk-nx/core/lib/pipes/capitalize/capitalize.pipe';
import { PricePipe } from '@valk-nx/core/lib/pipes/price/price.pipe';

import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl';

@Component({
	changeDetection: ChangeDetectionStrategy.Default,
	imports: [
		AngularSvgIconModule,
		CommonModule,
		SharedModule,
		TooltipModule,
		ReceiptSummaryExtraComponent,
		PricePipe,
		CapitalizePipe,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	selector: `vp-receipt-summary-item`,
	templateUrl: './item.component.html',
})
export class ReceiptSummaryItemComponent {
	item = input.required<Item | ItemWithExtras>();
	currency = input.required<string>();
	index = input.required<number>();
	totalNumberOfItems = input.required<number>();
	someItemHasExtras = input.required<boolean>();

	addedRoomCostsTotal = computed<number>(() => {
		const item = this.itemWithExtras();
		if (item) {
			if (item.additionalCharges) {
				return item.additionalCharges + item.totalPrice;
			}
			return item.totalPrice;
		}
		return 0;
	});

	itemWithExtras = computed<ItemWithExtras | undefined>(() => {
		const item = this.item();
		if (isItemWithExtras(item)) {
			return item;
		}
		return undefined;
	});
}
